import React from "react";
import DoingBusinessInSelect from "./DoingBusinessInSelect.jsx";
import { states } from "../../SSORequestAccountForm/Utility/state.js";

const AccountRow = props => {
  const {
    account,
    index,
    selected,
    onToggle,
    isEditMode,
    onStatusChange,
    onFieldChange,
    onOpenNotes,
    currentStatus,
    businessUnits,
    fieldChanges = {},
  } = props;

  // "Doing Business In" is edited with a restricted multi-select (DoingBusinessInSelect) whose
  // options are the same states as the public registration form, so admin edits produce a clean,
  // comma-separated full-name string (e.g. "New York, New Jersey") and free-text typos are no
  // longer possible. The value contract with the parent stays a comma-separated string, so nothing
  // downstream (applyBulkChanges / update API / stored procedure) needs to change.
  const doingBusinessInValue =
    fieldChanges.doingBusinessIn ?? account.doingBusinessIn ?? "";

  return (
    <tr key={index}>
      <td>
        <input
          type="checkbox"
          checked={selected}
          onChange={onToggle}
          disabled={isEditMode}
        />
      </td>
      <td>{account.source || "VU"}</td>
      <td className="approval-status">
        {isEditMode && selected ? (
          <>
            <select
              value={currentStatus}
              onChange={e => onStatusChange(account.userId, e.target.value)}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="rejected">Rejected</option>
            </select>
            {currentStatus !== account.accountStatus && (
              <div className="sso-account-approval__rejection-note">
                <label
                  htmlFor={`status-note-${index}`}
                  className="sso-account-approval__rejection-note-label"
                >
                  Note (required for status change)
                </label>
                <textarea
                  id={`status-note-${index}`}
                  className="sso-account-approval__rejection-note-input"
                  rows={2}
                  value={fieldChanges.statusNote ?? ""}
                  onChange={e =>
                    onFieldChange(account.userId, "statusNote", e.target.value)
                  }
                  placeholder={`Reason for changing status to ${currentStatus}...`}
                />
              </div>
            )}
          </>
        ) : (
          account.accountStatus
        )}
      </td>
      <td>
        {account.requestedDate
          ? new Date(account.requestedDate).toLocaleString()
          : ""}
      </td>
      <td>
        {isEditMode && selected ? (
          <input
            type="text"
            value={fieldChanges.firstName ?? account.firstName}
            onChange={e => onFieldChange(account.userId, "firstName", e.target.value)}
          />
        ) : (
          account.firstName
        )}
      </td>
      <td>
        {isEditMode && selected ? (
          <input
            type="text"
            value={fieldChanges.lastName ?? account.lastName}
            onChange={e => onFieldChange(account.userId, "lastName", e.target.value)}
          />
        ) : (
          account.lastName
        )}
      </td>
      <td>{account.email}</td>
      <td>
        {isEditMode && selected ? (
          <input
            type="text"
            value={fieldChanges.mobilePhone ?? account.mobilePhone}
            onChange={e => onFieldChange(account.userId, "mobilePhone", e.target.value)}
          />
        ) : (
          account.mobilePhone
        )}
      </td>
      <td>
        {isEditMode && selected ? (
          <input
            type="text"
            value={fieldChanges.officePhone ?? account.officePhone}
            onChange={e => onFieldChange(account.userId, "officePhone", e.target.value)}
          />
        ) : (
          account.officePhone
        )}
      </td>
      <td>
        {isEditMode && selected ? (
          <input
            type="text"
            value={fieldChanges.city ?? account.city}
            onChange={e => onFieldChange(account.userId, "city", e.target.value)}
          />
        ) : (
          account.city
        )}
      </td>
      <td>
        {isEditMode && selected ? (
          <input
            type="text"
            value={fieldChanges.state ?? account.state}
            onChange={e => onFieldChange(account.userId, "state", e.target.value)}
          />
        ) : (
          account.state
        )}
      </td>
      <td>
        {isEditMode && selected ? (
          <input
            type="text"
            value={fieldChanges.zipCode ?? account.zipCode}
            onChange={e => onFieldChange(account.userId, "zipCode", e.target.value)}
          />
        ) : (
          account.zipCode
        )}
      </td>
      <td>
        {isEditMode && selected ? (
          <input
            type="text"
            value={fieldChanges.companyName ?? account.companyName}
            onChange={e => onFieldChange(account.userId, "companyName", e.target.value)}
          />
        ) : (
          account.companyName
        )}
      </td>
     <td>
        {isEditMode && selected ? (
          <select
            value={fieldChanges.businessLine ?? account.businessLine}
            onChange={e => onFieldChange(account.userId, "businessLine", e.target.value)}
          >
            {businessUnits.map((unit, idx) => (
              <option key={idx} value={unit}> 
                {unit}
              </option>
            ))}
          </select>
        ) : (
          account.businessLine
        )}
      </td>
      <td>
        {isEditMode && selected ? (
          <DoingBusinessInSelect
            value={doingBusinessInValue}
            options={states}
            onChange={joined =>
              onFieldChange(account.userId, "doingBusinessIn", joined)
            }
          />
        ) : (
          account.doingBusinessIn
        )}
      </td>
      <td>{account.stewartContact}</td>
      <td>{account.stewartContactEmail}</td>
      <td>{account.approvedBy || ""}</td>
      <td>
        {account.approvedDate
          ? new Date(account.approvedDate).toLocaleString()
          : ""}
      </td>
      <td>
        {account.lastLoginDate
          ? new Date(account.lastLoginDate).toLocaleString()
          : "Never"}
      </td>
      <td>
        <button
          type="button"
          className="btn sso-account-approval__notes-button"
          onClick={() => onOpenNotes(account)}
        >
          View History
        </button>
      </td>
    </tr>
  );
};

export default AccountRow;
